import { useDispatch } from 'react-redux';
import * as Images from './../Images';
import './style.sass';
import { Text } from '@aws-amplify/ui-react';
import { Button } from 'react-bootstrap';
import * as Actions from '../../store/actions';
import { useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';

const QuestionAnswer = ({
  answer,
  showText = false,
  questionId,
  userAnswer,
  userQuizId,
  isReviewNew = false,
  topicId = '',
  topic = '',
  subtopic = '',
  subtopicId = '',
  isReviewFinished = false,
  correctAnswer = '',
  feedbackStatus = false,
  reviewObj = {},
  type = '',
  selectedQuizSection = '',
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onReviewClick = () => {
    dispatch(Actions.saveQuestionIdForReview(questionId));
    dispatch(Actions.saveUserQuizAnswer(userAnswer.toUpperCase()));
    dispatch(
      Actions.studentSelectedSectionBeforeReview({
        sectionId: selectedQuizSection,
        isUsed: false,
      }),
    );
    navigate('/step');
  };
  return (
    <div className="answer-row">
      {answer == 'correct' ? (
        <>
          <div className="answer-col">
            <img
              src={Images.correct}
              alt="correct"
              onClick={() => {
                if (isReviewFinished) {
                  dispatch(Actions.saveReviewStep(reviewObj));
                } else {
                  dispatch(Actions.saveReviewStep([]));
                }
                dispatch(Actions.saveReviewUserQuizId(userQuizId));
                dispatch(Actions.saveReviewIfNew(isReviewNew));
                dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                dispatch(
                  Actions.saveReviewTags({
                    topicId: topicId,
                    topic: topic,
                    subtopic: subtopic,
                    subtopicId: subtopicId,
                  }),
                );
                onReviewClick();
              }}
              style={{ cursor: 'pointer' }}
            />
            {showText ? <Text>Correct</Text> : ''}
          </div>
        </>
      ) : null}

      {answer == 'skipped' ? (
        <>
          {isReviewFinished ? (
            <div
              className={
                type === 'correctAnswer' ? 'answer-col' : ' answer-col answer-icon-incorrect'
              }
              style={{ cursor: 'pointer' }}
              onClick={() => {
                dispatch(Actions.saveReviewStep(reviewObj));
                dispatch(Actions.saveReviewUserQuizId(userQuizId));
                dispatch(Actions.saveReviewIfNew(isReviewNew));
                dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                dispatch(
                  Actions.saveReviewTags({
                    topicId: topicId,
                    topic: topic,
                    subtopic: subtopic,
                    subtopicId: subtopicId,
                  }),
                );
                onReviewClick();
              }}
            >
              {type === 'correctAnswer' ? (
                <>
                  <span className="answer-icon-line">{correctAnswer.toUpperCase()}</span>
                </>
              ) : (
                <>{correctAnswer.toUpperCase()}</>
              )}
            </div>
          ) : (
            <>
              <div className="answer-col">
                <img
                  src={Images.minus}
                  style={{ cursor: 'pointer' }}
                  alt="skipped"
                  onClick={() => {
                    dispatch(Actions.saveReviewStep(reviewObj));
                    dispatch(Actions.saveReviewUserQuizId(userQuizId));
                    dispatch(Actions.saveReviewIfNew(isReviewNew));
                    dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                    dispatch(
                      Actions.saveReviewTags({
                        topicId: topicId,
                        topic: topic,
                        subtopic: subtopic,
                        subtopicId: subtopicId,
                      }),
                    );
                    onReviewClick();
                  }}
                />
                {showText ? <Text>Skipped</Text> : ''}
              </div>
            </>
          )}
        </>
      ) : (
        ''
      )}

      {answer == 'incorrect' ? (
        <>
          {isReviewFinished ? (
            <div
              className={type === 'correctAnswer' ? 'answer-col' : ' answer-col answer-icon-skip'}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                dispatch(Actions.saveReviewStep(reviewObj));
                dispatch(Actions.saveReviewUserQuizId(userQuizId));
                dispatch(Actions.saveReviewIfNew(isReviewNew));
                dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                dispatch(
                  Actions.saveReviewTags({
                    topicId: topicId,
                    topic: topic,
                    subtopic: subtopic,
                    subtopicId: subtopicId,
                  }),
                );
                onReviewClick();
              }}
            >
              {type === 'correctAnswer' ? (
                <>
                  <span className="answer-icon-cross">{correctAnswer.toUpperCase()}</span>
                </>
              ) : (
                <>{correctAnswer.toUpperCase()}</>
              )}
            </div>
          ) : (
            <>
              <div className="answer-col">
                {type === 'correctAnswer' ? (
                  <>
                    <span
                      className="answer-icon-cross"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        dispatch(Actions.saveReviewStep(reviewObj));
                        dispatch(Actions.saveReviewUserQuizId(userQuizId));
                        dispatch(Actions.saveReviewIfNew(isReviewNew));
                        dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                        dispatch(
                          Actions.saveReviewTags({
                            topicId: topicId,
                            topic: topic,
                            subtopic: subtopic,
                            subtopicId: subtopicId,
                          }),
                        );
                        onReviewClick();
                      }}
                    >
                      {correctAnswer.toUpperCase()}
                    </span>
                  </>
                ) : (
                  <>
                    {' '}
                    <img
                      src={Images.cross}
                      alt="incorrect"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        dispatch(Actions.saveReviewStep([]));
                        dispatch(Actions.saveReviewUserQuizId(userQuizId));
                        dispatch(Actions.saveReviewIfNew(isReviewNew));
                        dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                        dispatch(
                          Actions.saveReviewTags({
                            topicId: topicId,
                            topic: topic,
                            subtopic: subtopic,
                            subtopicId: subtopicId,
                          }),
                        );
                        onReviewClick();
                      }}
                    />
                    {showText ? <Text>Incorrect</Text> : ''}
                  </>
                )}
              </div>
            </>
          )}
        </>
      ) : (
        ''
      )}
      {answer == 'review' ? (
        <div className="answer-col">
          {type === 'questionTopic' || type === 'questionSubTopic' ? (
            <FaLock style={{ color: 'gold' }} />
          ) : (
            <button
              className="btn btn-link review-button-animated"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                dispatch(Actions.saveReviewStep([]));
                dispatch(Actions.saveReviewUserQuizId(userQuizId));
                dispatch(Actions.saveReviewIfNew(isReviewNew));
                dispatch(Actions.saveReviewFeedbackStatus(feedbackStatus));
                dispatch(
                  Actions.saveReviewTags({
                    topicId: topicId,
                    topic: topic,
                    subtopic: subtopic,
                    subtopicId: subtopicId,
                  }),
                );
                onReviewClick();
              }}
            >
              <span className="review-button-text">Review</span>
              <span className="review-button-arrow">→</span>
            </button>
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default QuestionAnswer;
